import React, { useState, useEffect, useRef, useContext } from "react";
import { useSelector } from 'react-redux'
import { FlexContainer } from "heliocor-ui";

import { AccordionButton, AccordionIcon, AccordionContent } from './Accordion.styles'
import { AccordionContext } from "./AccordionManager";

const Accordion = React.forwardRef((
    {id, titleBox, contentBox, complete, index, warning, handleSelection = () => {}, isSingleDoc,
    lastChild, isOpen, isFree, disabled, higherAccordion, wizardContainerRef}, ref
    ) => {

    const [activeTab, setActiveTab] = useContext(AccordionContext)
    const [individualTab, setTabIndividual] = useState(isOpen && index)

    const [contentHeight, setContentHeight] = useState(0)
    const isActive = higherAccordion || isFree ? individualTab === index : activeTab === index

    const cafeStatus = useSelector(state => state.general.cafeStatus)

    const content = useRef(null)
    const isClosed = useRef(!isOpen)

    useEffect(() => {
        if(isSingleDoc) handleSelection()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    useEffect(() => { 
        if (cafeStatus === 'IMG_LOADED') {
            setContentHeight(content.current.scrollHeight) 
        }
    },[cafeStatus])

    useEffect(() => {
        if (disabled){
            isClosed.current = true
            setTabIndividual(null)
        }
    },[disabled])

    useEffect(() => {
        const scrollHeight = content.current.scrollHeight
        setContentHeight(higherAccordion ? scrollHeight + 288 : isActive ? scrollHeight : 0)
    },[activeTab, isActive, contentBox, index, higherAccordion])

    useEffect(() => {
        if (isOpen && isFree && isClosed.current) {
            setTabIndividual(index)
            isClosed.current = false
        }
    },[isOpen, isFree, isClosed, index])


    const handleClick = () => {

        handleSelection()
        
        if (wizardContainerRef) {
            setTimeout(() => {
                if (isActive) {
                    wizardContainerRef.current.scrollTo && wizardContainerRef.current.scrollTo({
                        top: ref.current.previousElementSibling.offsetTop,
                        behavior: 'smooth'
                    })
                } else {
                    wizardContainerRef.current.scrollTo && wizardContainerRef.current.scrollTo({
                        top: ref.current.offsetTop,
                        behavior: 'smooth'
                    })
                }
            }, 200)
        }
        if (isFree) return setTabIndividual(isActive ? null : index)
        setActiveTab(isActive ? null : index)
    }

    return (
        <FlexContainer column ref={ref}>
            <AccordionButton
                data-cy={id}
                active={isActive}
                complete={complete}
                warning={warning}
                onClick={handleClick}
                disabled={disabled}
            >
                {titleBox}
                <AccordionIcon active={isActive} width={10} fill={"#777"} />
            </AccordionButton>
            <AccordionContent
                ref={content}
                contentHeight={contentHeight}
                active={isActive}
                lastChild={lastChild}
            >
                {contentBox}
            </AccordionContent>
        </FlexContainer>
    )
})

export { Accordion };
